import React, { ComponentProps, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Column } from "../../DataTable";
import { CostCenter } from "../types";
import { useClubSlug } from "../../Clubs/hooks";
import AsyncFormInput from "@form/AsyncFormInput";
import { FormInput } from "@form/index";


interface Props extends ComponentProps<typeof FormInput> {
    name: string;
    label?: string;
    clubSlug?: string | null;
}

const CostCenterFormInput = ({ name, label, clubSlug: clubSlugProp, ...props }: Props) => {
    const { t } = useTranslation("invoice");
    const clubSlug = clubSlugProp ?? useClubSlug();
    const columns: Column<CostCenter>[] = useMemo(() => [
        { uid: "number", name: t('costCenter.columns.number') },
        { uid: "short_description", name: t('costCenter.columns.shortDescription') }
    ], [t]);

    const keyResolver = useCallback((item: CostCenter) => item.number, []);

    return <AsyncFormInput name={name} label={label} keyResolver={keyResolver} tableColumns={columns}
        fetchUrl={`invoice/${clubSlug}/cost-center`} inputProps={props}
    />;
};


export default CostCenterFormInput;
